var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.school)?_c('div',[_c('h2',{class:'text-uppercase '+_vm.styler},[_vm._v(_vm._s(_vm.school.name))]),(_vm.rsettings && _vm.rsettings[0].settings.motto)?_c('small',[_vm._v("Motto: "+_vm._s(_vm.school.motto))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }